/**
 * THE FIVE BILLING SECTIONS, ONCE — as ADDRESSES, and no longer as words.
 *
 * ── WHY FIVE SCREENS AND NOT ONE ──────────────────────────────────────────
 *
 * V2 stacked nine subjects into `my-plan.vue`: 1,370 lines with plan, cycle,
 * credits, packs, limits, add-ons, invoices, consumption and cancellation in a
 * single scroll. The value was never in the stacking — it is in each of those
 * controls, and none of them is lost here. What changes is that each subject got
 * an ADDRESS, and an address can be sent to a colleague ("look at the March
 * invoice") and bookmarked by whoever pays the bill.
 *
 * ── WHY THIS TABLE EXISTS INSTEAD OF LINKS WRITTEN BY HAND ────────────────
 *
 * For the same reason as `settings-tabs.ts`: the section bar and ⌘K both read
 * from here, and the sidebar keeps ONE line ("Billing"). If each screen wrote its
 * own bar, the fifth would be born missing from the other four — and nobody
 * reports a link that never existed.
 *
 * ── WHY THERE IS NO SENTENCE IN THIS FILE ─────────────────────────────────
 *
 * There were three per row: a label, a hint, and the synonyms ⌘K searches. They
 * were pt-BR literals, which is why `nav-items.ts` carried a `fallback` for them.
 * Each of the two readers now takes its words from the dictionary it already
 * mounts — the bar from `i18n/billing.ts` under `nav.<key>`, the palette from its
 * own `palette.billing.<key>` — because a component may mount only one local i18n
 * scope and neither reader can borrow the other's. A SIXTH section is therefore
 * born needing a name in both places; naming it in neither is what this comment
 * exists to prevent.
 */
export interface BillingSection {
	readonly to: string;
	/** The name under `nav.` in the dictionary, and under `palette.billing.` in ⌘K's. */
	readonly key: string;
}

export const BILLING_SECTIONS: readonly BillingSection[] = [
	{ to: "/billing", key: "plan" },
	{ to: "/billing/credits", key: "credits" },
	{ to: "/billing/limits", key: "limits" },
	{ to: "/billing/invoices", key: "invoices" },
	{ to: "/billing/consumption", key: "consumption" },
];
